import React, { useState, useEffect, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { AutoComplete } from "@progress/kendo-react-dropdowns";
import { Button } from "@progress/kendo-react-buttons";
import { xIcon } from "@progress/kendo-svg-icons";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import loadinggif from "../../assets/loading.gif";
import { process } from "@progress/kendo-data-query";
import { useProject } from '../../contexts/ProjectContext';
import { useEnvironmentConfigContext } from '../../contexts/EnvironmentConfigContext';
import { useHighlightedPoles } from '../../contexts/HighlightedPolesContext';
import { useQueryResults } from '../../contexts/QueryResultsContext';
import { useTabContext } from '../../contexts/ReportTabContext';
import { useUser } from '../../contexts/UserContext';
import SaveQueryPopup from "../../global_components/save_query_popup.js";
import { usePoleExportData, getFormattedFileName, executeExcelExport } from '../../global_components/poleExportHelper';

function ReliabilityReportPage() {
    //states to hold the categories from the webapi
    const [rejectStatusList, setRejectStatusList] = useState([]);
    const [inspectionConditionList, setInspectionConditionList] = useState([]);
    const [feederList, setFeederList] = useState([]);
    const [savedQueryList, setSavedQueryList] = useState([]);
    const [woodpeckerHolesList, setWoodpeckerHolesList] = useState([]);
    const [inspectionYearList, setInspectionYearList] = useState([]);
    const [inspectionStructureNumberList, setInspectionStructureNumberList] = useState([]);
    const [restorationStructureNumberList, setRestorationStructureNumberList] = useState([]);
    const [selectedInspectionList, setSelectedInspectionList] = useState([]);
    const [selectedRestorationList, setSelectedRestorationList] = useState([]);
    const [selectedCircuitList, setSelectedCircuitList] = useState([]);
    const [circuitIdList, setCircuitIdList] = useState([]);
    const [structureIdUGList, setStructureIdUGList] = useState([]);
    const [altStructureIdUGList, setAltStructureIdUGList] = useState([]);
    const [feederIdUGList, setFeederIdUGList] = useState([]);
    const [rejectStatusUGList1, setRejectStatusUGList1] = useState(["1"]);
    const [selectedStructureIDUGList, setSelectedStructureIDUGList] = useState([]);
    const [selectedAltStructureIDUGList, setSelectedAltStructureIDUGList] = useState([]);
    const [selectedFeederIDUGList, setSelectedFeederIDUGList] = useState([]);
    const [isUnderground, setisUnderground] = useState(false);

    //states to hold values for searching
    const [reportType, setReportType] = useState("Pole Inspection");
    const [reportDropdownValue, setReportDropdownValue] = useState({ id: 1, name: 'Pole Inspection' });
    
    const [rejectStatus, setRejectStatus] = useState("");
    const [selectedQuery, setSelectedQuery] = useState(null);
    const [woodpeckerHoles, setWoodpeckerHoles] = useState("");
    const [inspectionYear, setInspectionYear] = useState("");
    const [inspectionCondition, setInspectionCondition] = useState("");
    const [feeder, setFeeder] = useState("");
    const [structureNumber, setStructureNumber] = useState("");
    const [startAuditDate, setStartAuditDate] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [circuitId, setCircuitId] = useState("");
    const [notRestoredReasonList, setNotRestoredReasonList] = useState([]);
    const [endAuditDate, setEndAuditDate] = useState(null);
    const [structureIdUG, setStructureIdUG] = useState("");
    const [altStructureIdUG, setAltStructureIdUG] = useState("");
    const [feedIdUG, setFeederIdUG] = useState("");
    const [rejectStatusUG, setRejectStatusUG] = useState("");
    const [startAuditDateUG, setStartAuditDateUG] = useState(null);
    const [endAuditDateUG, setEndAuditDateUG] = useState(null);

    //utility states / other utilities
    const { user } = useUser();
    const { queryResults, setQueryResults, isQueryActive, activeQueryPayload, setActiveQueryPayload } = useQueryResults();
    const { selectedProject, GCP_Project, Dataset_ID} = useProject();
    const { highlightedPoles, setHighlightedPoles } = useHighlightedPoles();
    const [notRestoredReason, setNotRestoredReason] = useState("");
    const { selectedTab, setSelectedTab } = useTabContext();
    const [loading, setLoading] = useState(true);
    const [showWarning, setShowWarning] = useState(false);
    const [allExpanded, setAllExpanded] = useState();
    const [dataState, setDataState] = useState({ skip: 0, take: 10 });
    const [dataResult, setDataResult] = useState(process(queryResults, dataState));
    const [showSaveQueryPopup, setShowSaveQueryPopup] = useState(false);
    const [saveQueryOptions, setSaveQueryOptions] = useState(null);
    const [saveQueryError, setSaveQueryError] = useState("");
    const [showSaveSuccess, setShowSaveSuccess] = useState(false);

    const min = new Date(new Date().setFullYear(new Date().getFullYear() - 1));
    const excelExportRef = useRef(null);
    const gridWidth = 600;
    const navigate = useNavigate();
    const { environmentConfig } = useEnvironmentConfigContext();

    //returns bool if there is at least one valid entry 
    function isValidSubmit() {
        if (reportType === "Pole Inspection") {
            return (
                isValidEntry(rejectStatus) ||
                isValidEntry(inspectionCondition) ||
                isValidEntry(formatStructureNumberList(selectedInspectionList)) ||
                isValidEntry(feeder) ||
                isValidEntry(startAuditDate) ||
                isValidEntry(woodpeckerHoles) ||
                isValidEntry(inspectionYear) ||
                isValidEntry(endAuditDate)
            );
        } else if (reportType === "Pole Restoration"){
            return (
                isValidEntry(formatCircuitIdList(selectedCircuitList)) ||
                isValidEntry(formatStructureNumberList(selectedRestorationList)) ||
                isValidEntry(notRestoredReason) ||
                isValidEntry(startDate) ||
                isValidEntry(endDate)
            );
        } else if (reportType === "Pole Underground"){
            return (
                isValidEntry(formatCircuitIdList(selectedStructureIDUGList)) ||
                isValidEntry(formatCircuitIdList(selectedAltStructureIDUGList)) ||
                isValidEntry(formatCircuitIdList(selectedFeederIDUGList)) ||
                isValidEntry(rejectStatusUG) ||
                isValidEntry(startAuditDateUG) ||
                isValidEntry(endAuditDateUG)
            );
        }
        return false;
    }

    function isValidEntry(entry) {
        return !(entry == null || entry == "");
    }

    function resetQueryOptions() {
        setRejectStatus("");
        setInspectionCondition("");
        setFeeder("");
        setStructureNumber("");
        setStartAuditDate(null);
        setEndAuditDate(null);
        setStartAuditDateUG(null);
        setEndAuditDateUG(null);
        setStartDate(null);
        setEndDate(null);
        setCircuitId("");
        setNotRestoredReason("");
        setWoodpeckerHoles("");
        setInspectionYear("");
        setSelectedInspectionList([]);
        setSelectedRestorationList([])
        setSelectedCircuitList([]);
        setSelectedAltStructureIDUGList([]);
        setSelectedFeederIDUGList([]);
        setSelectedStructureIDUGList([]);
        setStructureIdUG("");
        setAltStructureIdUG("");
        setFeederIdUG("");
        setRejectStatusUG("");
    }

    function clearAllQueryFields() {
        resetQueryOptions();
        setSelectedQuery(null);
        setActiveQueryPayload(""); // Clear context payload cache
    }

    function buildSelectedQueryOptions() {
    return {
        Type: mappedType,
        StartDateAudit: reportType === "Pole Inspection" && startAuditDate ? startAuditDate.toISOString() : "",
        EndDateAudit: reportType === "Pole Inspection" && endAuditDate ? endAuditDate.toISOString() : "",
        RestorationStartDate: reportType === "Pole Restoration" && startDate ? startDate.toISOString() : "",
        RestorationEndDate: reportType === "Pole Restoration" && endDate ? endDate.toISOString() : "",
        StartDateAuditUG: reportType === "Pole Underground" && startAuditDateUG ? startAuditDateUG.toISOString() : "",
        EndDateAuditUG: reportType === "Pole Underground" && endAuditDateUG ? endAuditDateUG.toISOString() : "",
        RejectStatus: reportType === "Pole Inspection" ? (rejectStatus || "") : "",
        InspectionCondition: reportType === "Pole Inspection" ? (inspectionCondition || "") : "",
        WoodpeckerHoles: reportType === "Pole Inspection" ? (woodpeckerHoles || "") : "",
        InspectionYear: reportType === "Pole Inspection" ? (inspectionYear || "") : "",
        Feeder: reportType === "Pole Inspection" ? (feeder || "") : "",
        StructureNumber:
            reportType === "Pole Inspection"
                ? (formatStructureNumberList(selectedInspectionList) || "")
                : (formatStructureNumberList(selectedRestorationList) || ""),
        CircuitId: reportType === "Pole Restoration" ? formatCircuitIdList(selectedCircuitList) : "",
        NotRestoredReason: reportType === "Pole Restoration" ? (notRestoredReason || "") : "",
        StructureIdUG: reportType === "Pole Underground" ? formatCircuitIdList(selectedStructureIDUGList) : "",
        AltStructureIdUG: reportType === "Pole Underground" ? formatCircuitIdList(selectedAltStructureIDUGList) : "",
        FeederIdUG: reportType === "Pole Underground" ? formatCircuitIdList(selectedFeederIDUGList) : "",
        RejectStatusUG: reportType === "Pole Underground" ? (rejectStatusUG || "") : "",
        Pull_Type: ""
    };
}

    function openSaveQueryPopup() {
        if (!isValidSubmit()) {
            setShowWarning(true);
            return;
        }

        setShowWarning(false);
        setSaveQueryError("");
        setSaveQueryOptions(buildSelectedQueryOptions());
        setShowSaveQueryPopup(true);
    }

    function closeSaveQueryPopup() {
        setSaveQueryError("");
        setShowSaveQueryPopup(false);
    }

    function handleSaveQueryConfirm({ queryName, queryScope, queryOptions }) {
        const payloadToSave = {
            QueryName: queryName,
            QueryScope: queryScope,
            QueryPage: "ReliabilityReport",
            ReportType: reportType,
            Project: selectedProject,
            GCP_Project: GCP_Project,
            Dataset_ID: Dataset_ID,
            UserEmail: user?.email || "",
            QueryOptions: queryOptions
        };

        setSaveQueryError("");

        fetch(process.env.REACT_APP_WEB_API_URL + '/api-common/Secrets/GetNimblyWebAPIKey', {
            method: 'GET',
            headers: {
                'frontendenvironmentconfig': environmentConfig,
                'Content-Type': 'application/json'
            }
        })
            .then((res) => res.text())
            .then((apiKey) => {
                return fetch(process.env.REACT_APP_WEB_API_URL + '/api-common/poles/SaveQuery', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'ApiKey': apiKey,
                        'frontendenvironmentconfig': environmentConfig
                    },
                    body: JSON.stringify(payloadToSave)
                });
            })
            .then(async (res) => {
                if (!res.ok) {
                    const errorText = await res.text();
                    throw new Error(errorText || "Failed to save query.");
                }
                return res.json();
            })
            .then((data) => {
                console.log("Saved query successfully:", data);
                setSaveQueryError("");
                setShowSaveQueryPopup(false);
                fetchSavedQueries();
                setShowSaveSuccess(true);
                setTimeout(() => {
                    setShowSaveSuccess(false);
                }, 3000);
            })
            .catch((err) => {
                console.error("Error saving query:", err);

                let errorMessage = "Failed to save query.";

                if (err.message) {
                    if (err.message.includes("already exists")) {
                        errorMessage = "A saved query with this name already exists for this project.";
                    } else {
                        errorMessage = err.message;
                    }
                }

                setSaveQueryError(errorMessage);
            });
    }

    function fetchSavedQueries() {
        console.log("environmentConfig", environmentConfig);
        if (!selectedProject || !Dataset_ID || !user?.email) return;

        fetch(process.env.REACT_APP_WEB_API_URL + '/api-common/Secrets/GetNimblyWebAPIKey', {
            method: 'GET',
            headers: {
                'frontendenvironmentconfig': environmentConfig,
                'Content-Type': 'application/json'
            }
        })
            .then((res) => res.text())
            .then((apiKey) => {
                return fetch(process.env.REACT_APP_WEB_API_URL + '/api-common/poles/GetSavedQueries', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'ApiKey': apiKey,
                        'frontendenvironmentconfig': environmentConfig
                    },
                    body: JSON.stringify({
                        QueryPage: "ReliabilityReport",
                        Project: selectedProject,
                        Dataset_ID: Dataset_ID,
                        UserEmail: user.email
                    })
                });
            })
            .then((res) => {
                if (!res.ok) {
                    throw new Error("Failed to fetch saved queries.");
                }
                return res.json();
            })
            .then((data) => {
                setSavedQueryList(data || []);
            })
            .catch((err) => {
                console.error("Error fetching saved queries:", err);
            });
    }

    function handleSavedQueryChange(e) {
        const selected = e.target.value;
        setSelectedQuery(selected);

        if (!selected) return;

        const options = selected.QueryOptions || {};
        const nextReportType = selected.ReportType || "Pole Inspection";

        resetQueryOptions();
        setReportType(nextReportType);

        const reportOption =
            nextReportType === "Pole Inspection"
                ? { id: 1, name: "Pole Inspection" }
                : nextReportType === "Pole Restoration"
                    ? { id: 2, name: "Pole Restoration" }
                    : { id: 3, name: "Pole Underground" };

        setReportDropdownValue(reportOption);

        if (nextReportType === "Pole Inspection") {
            setStartAuditDate(options.StartDateAudit ? new Date(options.StartDateAudit) : null);
            setEndAuditDate(options.EndDateAudit ? new Date(options.EndDateAudit) : null);
            setRejectStatus(options.RejectStatus || "");
            setInspectionCondition(options.InspectionCondition || "");
            setFeeder(options.Feeder || "");
            setWoodpeckerHoles(options.WoodpeckerHoles || "");
            setInspectionYear(options.InspectionYear || "");

            if (options.StructureNumber) {
                const parsedList = options.StructureNumber
                    .split(",")
                    .map(x => x.replace(/"/g, "").trim())
                    .filter(Boolean);
                setSelectedInspectionList(parsedList);
            }
        } else if (nextReportType === "Pole Restoration") {
            setStartDate(options.RestorationStartDate ? new Date(options.RestorationStartDate) : null);
            setEndDate(options.RestorationEndDate ? new Date(options.RestorationEndDate) : null);
            setNotRestoredReason(options.NotRestoredReason || "");

            if (options.CircuitId) {
                const parsedCircuits = options.CircuitId
                    .split(",")
                    .map(x => x.replace(/"/g, "").trim())
                    .filter(Boolean);
                setSelectedCircuitList(parsedCircuits);
            }

            if (options.StructureNumber) {
                const parsedStructures = options.StructureNumber
                    .split(",")
                    .map(x => x.replace(/"/g, "").trim())
                    .filter(Boolean);
                setSelectedRestorationList(parsedStructures);
            }
        } else if (nextReportType === "Pole Underground") {
            setRejectStatusUG(options.RejectStatusUG || "");
            setStartAuditDateUG(options.StartDateAuditUG ? new Date(options.StartDateAuditUG) : null);
            setEndAuditDateUG(options.EndDateAuditUG ? new Date(options.EndDateAuditUG) : null);

            if (options.StructureIdUG) {
                const parsedStructureUG = options.StructureIdUG
                    .split(",")
                    .map(x => x.replace(/"/g, "").trim())
                    .filter(Boolean);
                setSelectedStructureIDUGList(parsedStructureUG);
            }

            if (options.AltStructureIdUG) {
                const parsedAltStructureUG = options.AltStructureIdUG
                    .split(",")
                    .map(x => x.replace(/"/g, "").trim())
                    .filter(Boolean);
                setSelectedAltStructureIDUGList(parsedAltStructureUG);
            }

            if (options.FeederIdUG) {
                const parsedFeederUG = options.FeederIdUG
                    .split(",")
                    .map(x => x.replace(/"/g, "").trim())
                    .filter(Boolean);
                setSelectedFeederIDUGList(parsedFeederUG);
            }
        }
    }

    // MAPPING THE POLE / REPORT TYPE TO EXPECTED VERBIAGE FOR BQ 
    const mappedType = reportType === "Pole Inspection"
        ? "Inspection Pole"
        : reportType === "Pole Restoration"
            ? "Restoration Pole"
            : "Underground Pole";

   function fetchQueryResults(payload) {
        console.log("Executing body payload:", payload);
        setLoading(true);
        try {
            fetch(process.env.REACT_APP_WEB_API_URL + '/api-common/Secrets/GetNimblyWebAPIKey', {
                method: 'GET',
                headers: { 'frontendenvironmentconfig': environmentConfig, 'Content-Type': 'application/json' }
            })
                .then((res) => res.text())
                .then((apiKey) => {
                    fetch(process.env.REACT_APP_WEB_API_URL + '/api-common/poles/GetRSUGPoles', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'ApiKey': apiKey,
                            'frontendenvironmentconfig': environmentConfig
                        },
                        body: payload,
                    })
                        .then((res) => res.json())
                        .then((data) => {
                            const flattenedData = data.map(item => ({
                                GlobalId: item.GlobalId,
                                fieldDict: item.fieldDict,
                                photosDict: item.photosDict
                            }));
                            // console.log('flattenedData:', flattenedData);
                            setSelectedTab(1);
                            setQueryResults(flattenedData);
                            setDataState({
                                skip: 0,
                                take: 10
                            });
                            setAllExpanded(false);
                            setLoading(false);
                        });
                });
        } catch (ex) {
            console.log("<------------------------------>");
            console.log("Error executing query");
            console.log(ex);
        }     
    }

    function populateDropdownData() {
        setLoading(true);
        try {
            fetch(process.env.REACT_APP_WEB_API_URL + '/api-common/Secrets/GetNimblyWebAPIKey', {
                method: 'GET',
                headers: { 'frontendenvironmentconfig': environmentConfig, 'Content-Type': 'application/json', "Access-Control-Allow-Origin": "*" },
            })
                .then((res) => {
                    return res.text();
                })
                .then((data) => {
                    fetch(process.env.REACT_APP_WEB_API_URL + '/api-common/poles/GetUGCategories', {
                        method: 'POST',
                        headers: { 'frontendenvironmentconfig': environmentConfig, 'Content-Type': 'application/json', 'ApiKey': data, },
                        body: JSON.stringify({
                            rawQuery: "",
                            Project: selectedProject,
                            GCP_Project: GCP_Project,
                            Dataset_ID: Dataset_ID
                        })
                    })
                        .then((res) => {
                            return res.json();
                        })
                        .then((data) => {
                            //Each item being passed from data is a dictionary<string, byte>
                            //Since there is no concurrent set in C# this was the best alternative for concurrency

                            setRejectStatusUGList1(Object.keys(data.RejectStatusUG));
                            setRejectStatusList(Object.keys(data.RejectStatus));
                            setInspectionConditionList(Object.keys(data.InspectionCondition));
                            setFeederList(Object.keys(data.Feeder));
                            setInspectionStructureNumberList(Object.keys(data.InspectionStructureNumber));
                            setRestorationStructureNumberList(Object.keys(data.RestorationStructureNumber))
                            setCircuitIdList(Object.keys(data.CircuitId));
                            setNotRestoredReasonList(Object.keys(data.NotRestoredReason));
                            setStructureIdUGList(Object.keys(data.StructureIDUG));
                            setAltStructureIdUGList(Object.keys(data.AltStructureIDUG));
                            setFeederIdUGList(Object.keys(data.FeederIDUG));
                            setWoodpeckerHolesList(Object.keys(data.WoodpeckerPoles));
                            setInspectionYearList(Object.keys(data.InspectionYear));
                            setisUnderground(data.Underground);
                            setLoading(false);
                        });
                });
        } catch (ex) {
            console.log("<------------------------------>");
            console.log("Error fetching rs categories");
            console.log(ex);
        } 
    }

    const flattenObject = (obj, parentKey = '', result = {}) => {
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                const newKey = parentKey ? `${parentKey}.${key}` : key;
                if (obj[key] && typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
                    flattenObject(obj[key], newKey, result);
                } else {
                    result[newKey] = obj[key];
                }
            }
        }
        return result;
    };

    // Pull export memoized data configurations directly from the helper hook
    const { exportData, columns } = usePoleExportData(queryResults);

    const exportRows = () => {
        executeExcelExport(excelExportRef, exportData);
    };

    function submitQuery() {
        if (!isValidSubmit()) {
            setShowWarning(true);
            return;
        }
        setShowWarning(false);
        const newPayload = JSON.stringify({
            Type: mappedType,
            StartDateAudit: reportType === "Pole Inspection" ? (startAuditDate || "") : "",
            EndDateAudit: reportType === "Pole Inspection" ? (endAuditDate || "") : "",
            RestorationStartDate: reportType === "Pole Restoration" ? (startDate || "") : "",
            RestorationEndDate: reportType === "Pole Restoration" ? (endDate || "") : "",
            RejectStatus: reportType === "Pole Inspection" ? (rejectStatus || "") : "",
            InspectionCondition: reportType === "Pole Inspection" ? (inspectionCondition || "") : "",
            WoodpeckerHoles: reportType === "Pole Inspection" ? (woodpeckerHoles || "") : "",
            InspectionYear: reportType === "Pole Inspection" ? (inspectionYear || "") : "",
            Feeder: reportType === "Pole Inspection" ? (feeder || "") : "",
            StructureNumber: reportType === "Pole Inspection" ? (formatStructureNumberList(selectedInspectionList) || "") : (formatStructureNumberList(selectedRestorationList) || ""),
            CircuitId: reportType === "Pole Restoration"
                ? formatCircuitIdList(selectedCircuitList)
                : "",
            NotRestoredReason: reportType === "Pole Restoration" ? (notRestoredReason || "") : "",
            Project: selectedProject,
            GCP_Project: GCP_Project,
            Dataset_ID: Dataset_ID,
            Pull_Type: "",
            StructureIdUG: reportType === "Pole Underground" ? formatCircuitIdList(selectedStructureIDUGList) : "",
            AltStructureIdUG: reportType === "Pole Underground" ? formatCircuitIdList(selectedAltStructureIDUGList) : "",
            FeederIdUG: reportType === "Pole Underground" ? formatCircuitIdList(selectedFeederIDUGList) : "",
            RejectStatusUG: reportType === "Pole Underground" ? (rejectStatusUG || "") : "",
            StartDateAuditUG: reportType === "Pole Underground" ? (startAuditDateUG || "") : "",
            EndDateAuditUG: reportType === "Pole Underground" ? (endAuditDateUG || "") : "",
        });

        setActiveQueryPayload(newPayload);
        fetchQueryResults(newPayload);
    }

    function expandChange(event){
        const isExpanded = event.dataItem.expanded === undefined ? event.dataItem.aggregates : event.dataItem.expanded;
        event.dataItem.expanded = !isExpanded;
        setDataResult({
            ...dataResult,
            data: [...dataResult.data],
        });
    };

    function expandAllRows(shouldExpand) {
        let updatedExpandStatus = !allExpanded;
        let newData = queryResults.map((item) => {
            item.expanded = updatedExpandStatus
            return item;
        });
        setDataResult({
            ...dataResult,
            data: [...dataResult.data],
        });
        setAllExpanded(!allExpanded);
    };

    const viewInMap = () => {
        const highlightedPolesList = queryResults.map(item => item.GlobalId);
        setHighlightedPoles(highlightedPolesList);
        const updatedPoleData = queryResults.map(item => ({
            ...item,
            highlighted: highlightedPolesList.includes(item.GlobalId)
        }));

        navigate('/map');
    };

    function dataStateChange(event) {
        setDataResult(process(queryResults, event.dataState));
        setDataState(event.dataState);
    };

    function setPercentage(percentage) {
        return Math.round(gridWidth / 100) * percentage;
    }

    function handleStructureNumberChange(e) {
        const tempNumber = e.target.value;
        const isSelected = inspectionStructureNumberList.includes(tempNumber);
        const inStructureNumberList = selectedInspectionList != null ? selectedInspectionList.includes(tempNumber) : false;
        if (isSelected && !inStructureNumberList) {
            if (selectedInspectionList != null) {
                setStructureNumber(e.target.value);
                                                if(!isEmptyOrWhitespace(tempNumber)){

                setSelectedInspectionList(oldArray => [tempNumber, ...oldArray]);
                                                }
            } else {
                let temp = [tempNumber];
                setStructureNumber(e.target.value);
                                                if(!isEmptyOrWhitespace(tempNumber)){

                setSelectedInspectionList(temp);
                                                }
            }
        } else {
            setStructureNumber(e.target.value);
        }
    };

    function handleRestorationStructureNumberChange(e) {
        const tempNumber = e.target.value;
        const isSelected = restorationStructureNumberList.includes(tempNumber);
        const inStructureNumberList = selectedRestorationList != null ? selectedRestorationList.includes(tempNumber) : false;
        if (isSelected && !inStructureNumberList) {
            if (selectedRestorationList != null) {
                setStructureNumber(e.target.value);
                setSelectedRestorationList(oldArray => [tempNumber, ...oldArray]);
            } else {
                let temp = [tempNumber];
                setStructureNumber(e.target.value);
                setSelectedRestorationList(temp);
            }
        } else {
            setStructureNumber(e.target.value);
        }
    };

    function handleCircuitIdChange(e) {
        const tempNumber = e.target.value;
        const isSelected = circuitIdList.includes(tempNumber);
        const inCircuitIdList = selectedCircuitList != null ? selectedCircuitList.includes(tempNumber) : false;
        if (isSelected && !inCircuitIdList) {
            if (selectedCircuitList != null) {
                setCircuitId(e.target.value);
                setSelectedCircuitList(oldArray => [tempNumber, ...oldArray]);
            } else {
                let temp = [tempNumber];
                setCircuitId(e.target.value);
                setSelectedCircuitList(temp);
            }
        } else {
            setCircuitId(e.target.value);
        }
    };

    function isEmptyOrWhitespace(str) {
        return str.trim() === "";
    }

    function handleStructureIdUGChange(e) {
        const tempNumber = e.target.value;
        const isSelected = structureIdUGList.includes(tempNumber);
        const inSelectedList = selectedStructureIDUGList != null ? selectedStructureIDUGList.includes(tempNumber) : false;
        if (isSelected && !inSelectedList) {
            if (selectedStructureIDUGList != null) {
                setStructureIdUG(e.target.value);
                if(!isEmptyOrWhitespace(tempNumber)){
                    setSelectedStructureIDUGList(oldArray => [tempNumber, ...oldArray]);
                }
            } else {
                let temp = [tempNumber];
                setStructureIdUG(e.target.value);
                if(!isEmptyOrWhitespace(tempNumber)){
                    setSelectedStructureIDUGList(temp);
                }
            }
        } else {
            setStructureIdUG(e.target.value);
        }
        }


    function handleReprotTypeChange(e) {
        const reportValue = e.target.value.name;
        const reportDropdownSelectedValue = e.target.value;
        resetQueryOptions();
        setSelectedQuery(null);
        setReportType(reportValue);
        setReportDropdownValue(reportDropdownSelectedValue);
    };

    function handleAltStructureIdUGChange(e) {
        const tempNumber = e.target.value;
        const isSelected = altStructureIdUGList.includes(tempNumber);
        const inSelectedList = selectedAltStructureIDUGList != null ? selectedAltStructureIDUGList.includes(tempNumber) : false;
        if (isSelected && !inSelectedList) {
            if (selectedAltStructureIDUGList != null) {
                setAltStructureIdUG(e.target.value);
                if(!isEmptyOrWhitespace(tempNumber)){
                    setSelectedAltStructureIDUGList(oldArray => [tempNumber, ...oldArray]);
                }
            } else {
                let temp = [tempNumber];
                setAltStructureIdUG(e.target.value);
                if(!isEmptyOrWhitespace(tempNumber)){
                    setSelectedAltStructureIDUGList(temp);
                }
            }
        } else {
            setAltStructureIdUG(e.target.value);
        }
    };

    function handleFeederIdUGChange(e) {
        const tempNumber = e.target.value;
        const isSelected = feederIdUGList.includes(tempNumber);
        const inSelectedList = selectedFeederIDUGList != null ? selectedFeederIDUGList.includes(tempNumber) : false;
        if (isSelected && !inSelectedList) {
            if (selectedFeederIDUGList != null) {
                setFeederIdUG(e.target.value);
                if(!isEmptyOrWhitespace(tempNumber)){
                    setSelectedFeederIDUGList(oldArray => [tempNumber, ...oldArray]);
                }
            } else {
                let temp = [tempNumber];
                setFeederIdUG(e.target.value);
                if(!isEmptyOrWhitespace(tempNumber)){
                    setSelectedFeederIDUGList(temp);
                }
            }
        } else {
            setFeederIdUG(e.target.value);
        }
    };

    function formatStructureNumberList(li){
        let ret = "";
        if (li != null) {
            li.forEach(el => {
                ret += "\"" + el + "\"" + ",";
            });
        }
        return ret.substr(0, ret.length - 1);
    }

    function formatCircuitIdList(list) {
        return list ? list.map(el => `"${el}"`).join(",") : "";
    }


    useEffect(() => {
        if (selectedProject) {
            populateDropdownData();
            resetQueryOptions();
            setSelectedQuery(null);
            setDataResult(process([], dataState));
        }
        setDataResult({
            ...dataResult,
            data: [...dataResult.data],
        });
    }, [selectedProject]);

    useEffect(() => {
        if (selectedProject && Dataset_ID && user?.email) {
            fetchSavedQueries();
        } else {
            setSavedQueryList([]);
            setSelectedQuery(null);
        }
    }, [selectedProject, Dataset_ID, user?.email, environmentConfig]);

    useEffect(() => {
        const allRowsExpanded = queryResults.length > 0 && queryResults.every(item => item.expanded);
        setAllExpanded(allRowsExpanded);
    }, [queryResults]);

    useEffect(() => {
        setDataResult(process(queryResults, dataState));
    }, [queryResults]);

    function SelectedPoleNumbers({ props, onRemove }) {
        if (!props || props.length === 0) {
            return <div />;
        }

        return (
            <div className="pulse-multi-pole-wrapper">
                {props.map((num) => (
                    <div className="pulse-multi-pole" key={num}>
                        <div className="pulse-multi-pole-label">{num}</div>
                        <Button
                            svgIcon={xIcon}
                            onClick={() => onRemove(num)}
                            className="pulse-multi-pole-x"
                            fillMode="link"
                        />
                    </div>
                ))}
            </div>
        );
    }

    //detail components for the datagrid
    function DetailComponent(props) {
        //Current there is no attachments for rs projects
        //If added they will need to be reimplemnted
        const dataItem = props.dataItem;
        let last = 3;
        let first = 1;
        const picCol = dataItem.photosDict && Object.keys(dataItem.photosDict).length > 0 ? first++ : last--;
        const locationCol = first++;
        const infoCol = first++;
        const renderFieldItems = (fields) => {
            return Object.entries(fields).map(([key, value], index) => (
                <React.Fragment key={index}>
                    <GridLayoutItem className="pulse-queryresult-expanded-detail-column" row={index + 2} col={1}>
                        {"Pole " + key.replace(/_/g, ' ')}:
                </GridLayoutItem>
                    <GridLayoutItem row={index + 2} col={2}>
                        {value}
                    </GridLayoutItem>
                </React.Fragment>
            ));
        };

        function Photos() {
            return (
                <GridLayoutItem className="pulse-img-container" row={1} col={picCol}>
                    {dataItem.photosDict && Object.values(dataItem.photosDict).map((photo, x) => (
                        <a href={photo['Photo Path']} target="_blank" rel="noopener noreferrer" key={x}>
                            <img className="pulse-img" src={photo['Photo Path']} alt={`Photo ${x + 1}`} />
                        </a>
                    ))}
                </GridLayoutItem>
            );
        }

        function Info() {
            return (
                <GridLayoutItem className="pulse-expand-content pulse-img-container" row={1} col={infoCol}>
                    <GridLayout
                        gap={{ rows: 14, cols: 2, }}
                        cols={[
                            { width: "49%", },
                            { width: "49%", }
                        ]}
                    >
                        <GridLayoutItem className="pulse-expand-title" row={1} col={1} colSpan={2}>
                            Pole Information
                    </GridLayoutItem>
                        {
                            // renderFieldItems(reportType !== "Pole Underground" ? dataItem.fieldDict.Poles:dataItem.fieldDict.Underground)
                            renderFieldItems(dataItem.fieldDict.Poles)
                        }
                    </GridLayout>
                </GridLayoutItem>
            );
        }

        function Location() {
            return (
                <GridLayoutItem className="pulse-expand-content pulse-img-container" row={1} col={locationCol}>
                    <GridLayout
                        gap={{ rows: 8, cols: 2, }}
                        cols={[
                            { width: "49%", },
                            { width: "49%", }
                        ]}
                    >
                        <GridLayoutItem className="pulse-expand-title" row={1} col={1} colSpan={2}>
                            Location Details
                        </GridLayoutItem>
                        {renderFieldItems(dataItem.fieldDict.Location_Details)}
                    </GridLayout>
                </GridLayoutItem>
            );
        }

        return (
            <GridLayout
                gap={{ rows: 2, cols: 4, }}
                rows={[
                    { height: 250, }
                ]}
                cols={[
                    { width: "25%", },
                    { width: "25%", },
                    { width: "25%", },
                    { width: "25%", }
                ]}
            >
                {dataItem.photosDict && Object.keys(dataItem.photosDict).length > 0 ? <Photos /> : null}
                <Info />
                <Location />
            </GridLayout>
        )
    }

    const Warning = <div className="loading-icon-container"><img className='nimbly2-loader-gif' src={loadinggif} /> </div>;

    return (
        <div className="ken-nimbly-page-content-wrapper">
            {loading ? Warning : null}
            <TabStrip selected={selectedTab} onSelect={(e) => setSelectedTab(e.selected)}>
                <TabStripTab title="QUERY WIZARD">
                    <p className="ken-nimbly-ov-main-title">Query Wizard</p>
                    <div className="pulse-wizard-container">
                        <div className="pulse-wizard-container-header">Generate Query</div>
                        <div className={!showWarning ? "pulse-warning-no-display" : "pulse-wizard-container-warning"}>Please fill in at least one field to continue</div>
                        <div className={!showSaveSuccess ? "pulse-warning-no-display" : "pulse-wizard-container-success"}> Query saved successfully</div>
                        <div className="pulse-wizard-container-2">
                            <GridLayout
                                gap={{ rows: 8, cols: 2 }}
                                cols={[{ width: 150 }]}
                            >
                                {/* --- SELECT A QUERY --- */}
                                <GridLayoutItem row={1} col={1} colSpan={7}>
                                    <p className="Pulse-report-form-title">APPLY A SAVED QUERY</p>
                                    <div className="box-divider"></div>
                                </GridLayoutItem>

                                <GridLayoutItem className="pulse-querywizard-column-text" row={2} col={1}>
                                    Query:
                                </GridLayoutItem>
                                <GridLayoutItem row={2} col={2} colSpan={6}>
                                    <DropDownList
                                        data={savedQueryList}
                                        textField="QueryName"
                                        dataItemKey="Id"
                                        value={selectedQuery}
                                        onChange={(e) => handleSavedQueryChange(e)}
                                    />
                                </GridLayoutItem>

                                {/* --- SELECT REPORT --- */}
                                <GridLayoutItem row={3} col={1} colSpan={7}>
                                    <p className="Pulse-report-form-title">SELECT REPORT</p>
                                    <div className="box-divider"></div>
                                </GridLayoutItem>

                                <GridLayoutItem className="pulse-querywizard-column-text" row={4} col={1}>
                                    Report Type:
                                </GridLayoutItem>
                                <GridLayoutItem row={4} col={2} colSpan={6}>
                                    <DropDownList
                                        data={
                                            [
                                                { id: 1, name: 'Pole Inspection' },
                                                { id: 2, name: 'Pole Restoration' },
                                                { id: 3, name:'Pole Underground'},

                                            ]
                                        }
                                        textField="name"
                                        dataItemKey="id"
                                        value={reportDropdownValue}
                                        onChange={(e) => handleReprotTypeChange(e)}
                                    />
                                </GridLayoutItem>

                                {reportType === "Pole Inspection" ? (
                                    <>
                                        {/* --- AUDIT DATE SECTION --- */}
                                        <GridLayoutItem row={5} col={1} colSpan={7}>
                                            <p className="Pulse-report-form-title">AUDIT DATE</p>
                                            <div className="box-divider"></div>
                                        </GridLayoutItem>
                                        <GridLayoutItem className="pulse-querywizard-column-text" row={6} col={1}>
                                            Start Date:
                                        </GridLayoutItem>
                                        <GridLayoutItem row={6} col={2}>
                                            <DatePicker
                                                min={min}
                                                value={startAuditDate}
                                                placeholder="Choose a date..."
                                                onChange={(e) => setStartAuditDate(e.value)}
                                            />
                                        </GridLayoutItem>
                                        <GridLayoutItem className="pulse-querywizard-column-text" row={6} col={3}>
                                            End Date:
                                        </GridLayoutItem>
                                        <GridLayoutItem row={6} col={4}>
                                            <DatePicker
                                                min={min}
                                                value={endAuditDate}
                                                placeholder="Choose a date..."
                                                onChange={(e) => setEndAuditDate(e.value)}
                                            />
                                        </GridLayoutItem>

                                        {/* --- POLE INFO SECTION --- */}
                                        <GridLayoutItem row={7} col={1} colSpan={7}>
                                            <p className="Pulse-report-form-title">PROJECT INFO</p>
                                            <div className="box-divider"></div>
                                        </GridLayoutItem>
                                        <GridLayoutItem className="pulse-querywizard-column-text" row={8} col={1}>
                                            Reject Status:
                                        </GridLayoutItem>
                                        <GridLayoutItem row={8} col={2} colSpan={6}>
                                            <DropDownList
                                                data={rejectStatusList}
                                                value={rejectStatus}
                                                onChange={(e) => setRejectStatus(e.target.value)}
                                            />
                                        </GridLayoutItem>
                                        <GridLayoutItem className="pulse-querywizard-column-text" row={9} col={1}>
                                            Inspection Condition:
                                        </GridLayoutItem>
                                        <GridLayoutItem row={9} col={2} colSpan={6}>
                                            <DropDownList
                                                data={inspectionConditionList}
                                                value={inspectionCondition}
                                                onChange={(e) => setInspectionCondition(e.target.value)}
                                            />
                                        </GridLayoutItem>
                                        <GridLayoutItem className="pulse-querywizard-column-text" row={10} col={1}>
                                            Feeder:
                                        </GridLayoutItem>
                                        <GridLayoutItem row={10} col={2} colSpan={6}>
                                            <DropDownList
                                                data={feederList}
                                                value={feeder}
                                                onChange={(e) => setFeeder(e.target.value)}
                                            />
                                        </GridLayoutItem>
                                        <GridLayoutItem className="pulse-querywizard-column-text" row={11} col={1}>
                                            Structure Number:
                                        </GridLayoutItem>
                                        <GridLayoutItem row={11} col={2} colSpan={6}>
                                            <AutoComplete
                                                data={inspectionStructureNumberList}
                                                value={structureNumber}
                                                onChange={(e) => handleStructureNumberChange(e)}
                                            />
                                            <SelectedPoleNumbers props={selectedInspectionList} onRemove={(num) => setSelectedInspectionList(selectedInspectionList.filter(a => a !== num))} />
                                        </GridLayoutItem>
                                        <GridLayoutItem className="pulse-querywizard-column-text" row={12} col={1}>
                                            Woodpecker Holes:
                                        </GridLayoutItem>
                                        <GridLayoutItem row={12} col={2} colSpan={6}>
                                            <DropDownList
                                                data={woodpeckerHolesList}
                                                value={woodpeckerHoles}
                                                onChange={(e) => setWoodpeckerHoles(e.target.value)}
                                            />
                                        </GridLayoutItem>
                                        <GridLayoutItem className="pulse-querywizard-column-text" row={13} col={1}>
                                            Inspection Year:
                                        </GridLayoutItem>
                                        <GridLayoutItem row={13} col={2} colSpan={6}>
                                            <DropDownList
                                                data={inspectionYearList}
                                                value={inspectionYear}
                                                onChange={(e) => setInspectionYear(e.target.value)}
                                            />
                                        </GridLayoutItem>
                                    </>
                                ) : reportType === "Pole Restoration" ? (
                                    <>
                                        {/* --- RESTORATION DATE SECTION --- */}
                                        <GridLayoutItem row={5} col={1} colSpan={7}>
                                            <p className="Pulse-report-form-title">RESTORATION DATE</p>
                                            <div className="box-divider"></div>
                                        </GridLayoutItem>
                                        <GridLayoutItem className="pulse-querywizard-column-text" row={6} col={1}>
                                            Start Date:
                                            </GridLayoutItem>
                                        <GridLayoutItem row={6} col={2}>
                                            <DatePicker
                                                min={min}
                                                value={startDate}
                                                placeholder="Choose a date..."
                                                onChange={(e) => setStartDate(e.value)}
                                            />
                                        </GridLayoutItem>
                                        <GridLayoutItem className="pulse-querywizard-column-text" row={6} col={3}>
                                            End Date:
                                            </GridLayoutItem>
                                        <GridLayoutItem row={6} col={4}>
                                            <DatePicker
                                                min={min}
                                                value={endDate}
                                                placeholder="Choose a date..."
                                                onChange={(e) => setEndDate(e.value)}
                                            />
                                        </GridLayoutItem>

                                        {/* --- POLE RESTORATION INFO SECTION --- */}
                                        <GridLayoutItem row={7} col={1} colSpan={7}>
                                            <p className="Pulse-report-form-title">PROJECT INFO</p>
                                            <div className="box-divider"></div>
                                        </GridLayoutItem>
                                        <GridLayoutItem className="pulse-querywizard-column-text" row={8} col={1}>
                                            Circuit ID:
                                            </GridLayoutItem>
                                        <GridLayoutItem row={8} col={2} colSpan={6}>
                                            <AutoComplete
                                                data={circuitIdList}
                                                value={circuitId}
                                                onChange={(e) => handleCircuitIdChange(e)}
                                            />
                                            <SelectedPoleNumbers props={selectedCircuitList} onRemove={(num) => setSelectedCircuitList(selectedCircuitList.filter(a => a !== num))} />
                                        </GridLayoutItem>
                                        <GridLayoutItem className="pulse-querywizard-column-text" row={9} col={1}>
                                            Structure ID:
                                            </GridLayoutItem>
                                        <GridLayoutItem row={9} col={2} colSpan={6}>
                                            <AutoComplete
                                                data={restorationStructureNumberList}
                                                value={structureNumber}
                                                onChange={(e) => handleRestorationStructureNumberChange(e)}
                                            />
                                            <SelectedPoleNumbers props={selectedRestorationList} onRemove={(num) => setSelectedRestorationList(selectedRestorationList.filter(a => a !== num))} />
                                        </GridLayoutItem>
                                        <GridLayoutItem className="pulse-querywizard-column-text" row={10} col={1}>
                                            Not Restored Reason:
                                            </GridLayoutItem>
                                        <GridLayoutItem row={10} col={2} colSpan={6}>
                                            <DropDownList
                                                data={notRestoredReasonList}
                                                value={notRestoredReason}
                                                onChange={(e) => setNotRestoredReason(e.target.value)}
                                            />
                                        </GridLayoutItem>
                                    </>
                                ) : (
                                        <>
                                            {/* --- RESTORATION DATE SECTION --- */}
                                            <GridLayoutItem row={5} col={1} colSpan={7}>
                                                <p className="Pulse-report-form-title">AUDIT DATE</p>
                                                <div className="box-divider"></div>
                                            </GridLayoutItem>
                                            <GridLayoutItem className="pulse-querywizard-column-text" row={6} col={1}>
                                                Start Date:
                                            </GridLayoutItem>
                                            <GridLayoutItem row={6} col={2}>
                                                <DatePicker
                                                    min={min}
                                                    value={startAuditDateUG}
                                                    placeholder="Choose a date..."
                                                    onChange={(e) => setStartAuditDateUG(e.value)}
                                                />
                                            </GridLayoutItem>
                                            <GridLayoutItem className="pulse-querywizard-column-text" row={6} col={3}>
                                                End Date:
                                            </GridLayoutItem>
                                            <GridLayoutItem row={6} col={4}>
                                                <DatePicker
                                                    min={min}
                                                    value={endAuditDateUG}
                                                    placeholder="Choose a date..."
                                                    onChange={(e) => setEndAuditDateUG(e.value)}
                                                />
                                            </GridLayoutItem>

                                            {/* --- POLE RESTORATION INFO SECTION --- */}
                                            <GridLayoutItem row={7} col={1} colSpan={7}>
                                                <p className="Pulse-report-form-title">PROJECT INFO</p>
                                                <div className="box-divider"></div>
                                            </GridLayoutItem>
                                            <GridLayoutItem className="pulse-querywizard-column-text" row={8} col={1}>
                                                Structure ID:
                                            </GridLayoutItem>
                                            <GridLayoutItem row={8} col={2} colSpan={6}>
                                                <AutoComplete
                                                    data={structureIdUGList}
                                                    value={structureIdUG}
                                                    onChange={(e) => handleStructureIdUGChange(e)}
                                                />
                                                <SelectedPoleNumbers props={selectedStructureIDUGList} onRemove={(num) => setSelectedStructureIDUGList(selectedStructureIDUGList.filter(a => a !== num))} />
                                            </GridLayoutItem>
                                            <GridLayoutItem className="pulse-querywizard-column-text" row={9} col={1}>
                                                Alt Structure ID:
                                            </GridLayoutItem>
                                            <GridLayoutItem row={9} col={2} colSpan={6}>
                                                <AutoComplete
                                                    data={altStructureIdUGList}
                                                    value={altStructureIdUG}
                                                    onChange={(e) => handleAltStructureIdUGChange(e)}
                                                />
                                                <SelectedPoleNumbers props={selectedAltStructureIDUGList} onRemove={(num) => setSelectedAltStructureIDUGList(selectedAltStructureIDUGList.filter(a => a !== num))} />
                                            </GridLayoutItem>
                                                <GridLayoutItem className="pulse-querywizard-column-text" row={10} col={1}>
                                                    Feeder ID:
                                            </GridLayoutItem>
                                                <GridLayoutItem row={10} col={2} colSpan={6}>
                                                    <AutoComplete
                                                        data={feederIdUGList}
                                                        value={feedIdUG}
                                                        onChange={(e) => handleFeederIdUGChange(e)}
                                                    />
                                                    <SelectedPoleNumbers props={selectedFeederIDUGList} onRemove={(num) => setSelectedFeederIDUGList(selectedFeederIDUGList.filter(a => a !== num))} />
                                                </GridLayoutItem>
                                            <GridLayoutItem className="pulse-querywizard-column-text" row={11} col={1}>
                                                Reject Status:
                                            </GridLayoutItem>
                                            <GridLayoutItem row={11} col={2} colSpan={6}>
                                                <DropDownList
                                                    data={rejectStatusUGList1}
                                                    value={rejectStatusUG}
                                                    onChange={(e) => setRejectStatusUG(e.target.value)}
                                                />
                                            </GridLayoutItem>
                                        </>
                                        )}

                                <GridLayoutItem className="pulse-textalignment-center" row={15} col={2}>
                                    {/* --- SAVE QUERY BUTTON --- */}
                                    <Button
                                        type={"button"}              
                                        className="pulse-wizard-save-button"
                                        onClick={openSaveQueryPopup}
                                    >
                                        Save Query
                                    </Button>

                                    {/* --- CLEAR OPTIONS BUTTON --- */}
                                    <Button
                                        type={"button"}
                                        className="pulse-wizard-save-button"
                                        onClick={clearAllQueryFields}
                                    >
                                        Clear All
                                    </Button>

                                {/* --- EXECUTE QUERY BUTTON --- */}
                                    <Button
                                        themeColor={"primary"}
                                        type={"submit"}
                                        className="pulse-wizard-submit-button"
                                        onClick={submitQuery}
                                    >
                                        Execute Query
                                    </Button>
                                </GridLayoutItem>
                            </GridLayout>
                        </div>
                    </div>
                </TabStripTab>
                <TabStripTab title="QUERY REPORT">
                    <div className="pulse-query-wizard-top-row">
                        <p className="ken-nimbly-ov-main-title">Query Report</p>
                        <div className="report-action-btn-group">
                            <Button onClick={() => fetchQueryResults(activeQueryPayload)} disabled={!isQueryActive} className="pulse-expand-collapse-report-button">
                                <span>Get Latest Data</span>
                            </Button>
                            <Button onClick={() => viewInMap()} disabled={!isQueryActive} className="pulse-expand-collapse-report-button">
                                <span>View Results in Map</span>
                            </Button>
                            <Button onClick={() => expandAllRows()} disabled={queryResults.length === 0} className="pulse-expand-collapse-report-button">
                                <span>{allExpanded ? "Collapse" : "Expand"} All</span>
                            </Button>
                            <Button onClick={exportRows} disabled={queryResults.length === 0} className="pulse-expand-collapse-report-button">
                                <span>Export</span>
                            </Button>
                        </div>
                    </div>
                    <div>
                        <div className="pulse-wizard-container-header">Query Results</div>
                        <ExcelExport
                            key="reliability-report-excel-exporter"
                            ref={excelExportRef}
                            data={exportData}
                            columns={columns}
                            fileName={getFormattedFileName(selectedProject)}
                            // Fixes the double-clicking layout glitch by converting strings to executable code
                            onWorkbookCreate={(e) => {
                                e.workbook.sheets.forEach((sheet) => {
                                    sheet.rows.forEach((row) => {
                                        if (row.type === "data") {
                                            row.cells.forEach((cell) => {
                                                if (typeof cell.value === "string" && cell.value.startsWith("=")) {
                                                    cell.formula = cell.value.substring(1); 
                                                    cell.value = null; 
                                                }
                                            });
                                        }
                                    });
                                });
                            }}
                            rowOptions={{
                                headerRowHeight: 30,
                                dataRowHeight: 24
                            }}
                        />
                        <Grid
                            data={dataResult}
                            {...dataState}
                            onDataStateChange={dataStateChange}
                            detail={DetailComponent}
                            style={{
                                height: "100%",
                            }}
                            expandField="expanded"
                            onExpandChange={expandChange}
                            filterable={true}
                            pageable={{
                                buttonCount: 4,
                                pageSizes: [5, 10, 15, 20],
                            }}
                        >
                            <Column field={"fieldDict.Poles.Structure ID"} title="Structure ID" width={setPercentage(55)} />
                            <Column field={"fieldDict.Poles.Audit Date"} title="Audit Date" width={setPercentage(55)} />
                        </Grid>
                    </div>
                </TabStripTab>
            </TabStrip>
            {showSaveQueryPopup && (
                <SaveQueryPopup
                    queryOptions={saveQueryOptions}
                    saveError={saveQueryError}
                    onClose={closeSaveQueryPopup}
                    onConfirm={handleSaveQueryConfirm}
                />
            )}
        </div>
    );
}

export default ReliabilityReportPage;